export default __webpack_public_path__ + "static/media/0xadbf1854e5883eb8aa7baf50705338739e558e5b.c86f2c0c.svg";